import { FileText, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import { useState } from "react";
import { toast } from "sonner";

export default function Invoices() {
  const [loading, setLoading] = useState(false);

  const openCustomerPortal = async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase.functions.invoke("customer-portal");
      if (error) throw error;
      if (data?.url) {
        window.open(data.url, "_blank");
      }
    } catch (e) {
      console.error("Customer portal error:", e);
      toast.error("Kundenportal konnte nicht geöffnet werden.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-8 max-w-3xl space-y-6">
      <div>
        <h1 className="font-display text-2xl font-bold text-foreground mb-1">Rechnungen</h1>
        <p className="text-muted-foreground">
          Ihre Rechnungen und Zahlungshistorie werden sicher über unseren Zahlungsdienstleister verwaltet.
        </p>
      </div>

      <div className="rounded-xl border border-border bg-card p-8 text-center space-y-4">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-muted">
          <FileText className="h-6 w-6 text-muted-foreground" />
        </div>
        <h2 className="font-display text-lg font-semibold text-foreground">
          Rechnungen im Kundenportal
        </h2>
        <p className="text-sm text-muted-foreground max-w-md mx-auto">
          Alle Ihre Rechnungen, Zahlungsbelege und die aktuelle Zahlungsmethode
          können Sie bequem in Ihrem Zahlungsportal einsehen und verwalten.
        </p>
        <Button onClick={openCustomerPortal} disabled={loading} className="gap-2">
          <ExternalLink className="h-4 w-4" />
          {loading ? "Wird geöffnet…" : "Rechnungen anzeigen"}
        </Button>
      </div>
    </div>
  );
}
